import {
  FLASH_MESSAGE,
  FLASH_MESSAGE_RESET,
} from './types';

export function flashMessage(message, type = '', autoHideDuration = 6000) {
  return {
    type: FLASH_MESSAGE,
    payload: {
      message,
      show: true,
      type,
      autoHideDuration,
    },
  };
}

export function flashErrorMessage(err) {
  return (dispatch) => {
    dispatch(flashMessage(err.message, 'error'));
  };
}

export function resetFlashMessage() {
  return {
    type: FLASH_MESSAGE_RESET,
  };
}



// WEBPACK FOOTER //
// ./src/redux/flash/actions.js